// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { Route, Switch, withRouter } from "react-router-dom";
// Translations
import { withTranslation } from "react-i18next";
// Material
import { CircularProgress } from "@material-ui/core";
// Views
import RouteApp from "routes/application/route_app";
import RouteCreate from "routes/application/route_create";
import RouteEdit from "routes/application/route_edit";
import RouteOrder from "routes/application/route_order";
import RouteOrderStatus from "routes/application/route_order_status";
import RouteIntegrations from "routes/application/route_integrations";

// Infrastructure
import { ChargebeeAPI } from "views/Chargebee/infrastructure";
import { UsersAPI } from "views/Users/infrastructure";
// Components
import { Header } from "@components/Header";
import { MenuSidebar } from "@components/Sidebars";
import Plans from "views/Plans/application";
import Users from "views/Users/application/user";
import Notify from "components/Notifications/notify";
// Vendor
import { getRoleName } from "vendor/application";
import {
  hideNotify,
  resetState,
  updateInitApp,
  updatePlan,
  updatePlans,
  updateProjects,
  updateUser
} from "vendor/application/disptach";
import { handleActualTitle } from "@helpers";
import { IntegrationsAPI } from "../../Integrations/infrastructure";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: "",
      role: "",
      open: false
    };
  }

  componentDidMount = () => {
    handleActualTitle(this.props.t, "centrimanager");

    this.handleAccess();
    this.getPlans();
  };

  // method that reloads the component when the current project has been changed
  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // we SET the value from isNotify to false
    var notify = nextProps.data.notify;
    if (notify.isNotify) {
      var data = {
        message: notify.message,
        severity: notify.severity,
        from: notify.from,
        type: notify.type
      };
      this.props.dispatch(hideNotify(data));
    }
  };

  handleAccess = () => {
    const { access } = this.props.data;
    if (!access.isAccess) {
      this.props.dispatch(resetState());
      window.location.href = `${process.env.REACT_APP_URL_CENTRIBOT}`;
    } else {
      this.getUser();
    }
  };

  getUser = async () => {
    const { access } = this.props.data;
    try {
      let obj = new UsersAPI(access.userId, access, this.props);
      let user = await obj.get_user_info();
      let chargebee_api = new ChargebeeAPI(access.userId, access, this.props);
      let chargebee_customer = await chargebee_api.get_user_chargebee_id();

      user.chargebee_customer_id = chargebee_customer.chargebee_customer_id;
      user.chargebee_customer_site = chargebee_customer.site;
      var role = getRoleName(user.roles[0]);
      user.role_name = role;

      this.setState({ role: role });

      if (user.lang) {
        this.props.i18n.changeLanguage(user.lang);
      }

      this.props.dispatch(updateUser(user));
      this.getPlan(user);
      this.getProjects(user);
    } catch (err) {
      this.props.dispatch(resetState());
      window.location.href = `${process.env.REACT_APP_URL_CENTRIBOT}`;
    }
  };

  getProjects = async (user) => {
    const { access } = this.props.data;
    try {
      const obj = new IntegrationsAPI(
        user.account_id,
        access,
        this.props,
        user
      );
      let projects = await obj.get_projects();

      var get_projects = {
        all: projects.projects,
        active: projects.projects.filter(
          (project) => project.active && !project.sandbox
        )
      };

      this.props.dispatch(updateProjects(get_projects));

    } catch (err) {
      this.props.dispatch(resetState());
      window.location.href = `${process.env.REACT_APP_URL_CENTRIBOT}`;
    }
  };

  getPlan = async (user) => {
    const { access } = this.props.data;
    const { role } = this.state;
    const { history } = this.props;
    try {
      const obj = new UsersAPI(access.userId, access, this.props, user);
      let res = await obj.get_account_by_id(user.account_id);

      if (
        role !== "SuperAdministrator" &&
        role !== "Supervisor" &&
        role !== "Administrator" &&
        !res.to_delete
      ) {
        window.location.href = `${process.env.REACT_APP_URL_CENTRIBOT}`;
      }

      if (
        (role === "Supervisor" || role === "Administrator") &&
        !history.location.pathname.includes("users")
      ) {
        history.push("/users");
      }

      let chargebee_api = new ChargebeeAPI(access.userId, access, this.props);
      let chargebee_subscriptions =
        await chargebee_api.get_chargebee_user_subscriptions();

      res.chargebee_plans = chargebee_subscriptions;

      let chargebee_subcription_not_dummy = chargebee_subscriptions.filter(
        (sub) => !sub.is_dummy
      )[0];
      res.expiration_date =
        chargebee_subcription_not_dummy &&
        chargebee_subcription_not_dummy.chargebee_subscription_status ===
          "in_trial"
          ? chargebee_subcription_not_dummy.trial_end
          : res.expiration_date;

      this.props.dispatch(updatePlan(res));
      this.props.dispatch(updateInitApp(true));
    } catch (err) {
      this.props.dispatch(updateInitApp(true));
    }
  };

  getPlans = async () => {
    const { access } = this.props.data;
    try {
      const obj = new UsersAPI(access.userId, access, this.props, false);
      let res = await obj.get_plans();

      this.props.dispatch(updatePlans(res));
    } catch (err) {
      this.props.dispatch(updateInitApp(true));
    }
  };

  render() {
    const { user, access, initApp, notify, plan } = this.props.data,
      { t, history} = this.props,
      { role, open } = this.state;

    const isSuperAdministrator = user.role_name === "SuperAdministrator";
      if (isSuperAdministrator && history.location.pathname === "/") {
      history.push("/users");
    }
    return initApp && this.state.role && plan?.id ? (
      <React.Fragment>
        <Notify notify={notify} />
        <div className={"cen-app"}>
          <div className={"cen-container"}>
            <Header
              user={JSON.parse(JSON.stringify(user))}
              access={access}
              history={this.props.history}
              t={this.props.t}
              plan={plan}
            />
            <MenuSidebar
              user={user}
              open={open}
              handleMenuToggle={() => this.setState({ open: !open })}
              handleMenuClose={() => this.setState({ open: false })}
            />
            {role !== "SuperAdministrator" && plan.to_delete ? (
              <div className={"cen-info"}>
                <div>
                  <span>{t("notifications:frontend_info.expired.title")}</span>
                  <span>
                    {t("notifications:frontend_info.expired.description")}
                  </span>
                </div>
              </div>
            ) : (
              <Switch>
                  <Route path="/" exact component={Plans} />
                  <Route path="/users" exact component={Users} />
                <Route path="/:type" exact component={RouteApp} />
                <Route
                  path="/integrations/:channel"
                  component={RouteIntegrations}
                />
                <Route path="/:type/create" exact component={RouteCreate} />
                <Route path="/:type/edit/:id" exact component={RouteEdit} />
                <Route path="/order/:type" exact component={RouteOrder} />
                <Route
                  path="/order/:id/status"
                  exact
                  component={RouteOrderStatus}
                />
              </Switch>
            )}
          </div>
        </div>
      </React.Fragment>
    ) : (
      <div className="cen-init">
        <CircularProgress color="primary" size={70} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state
  };
};

const connect_app = connect(mapStateToProps)(App);

export default withTranslation(["common", "notifications"])(
  withRouter(connect_app)
);
